import { styled } from "styled-components";

export const Message = styled.p`
  font-size: 18px;
  text-align: center;
`;